import "should";

import { CustomAuthorizerEvent, CustomAuthorizerResult } from "aws-lambda";
import { Context } from "vm";

import { FlightTestHelper } from "../flight-test-helper";
import { AuthorizerHandler } from "./authorizer-handler";

describe("http-handler", () => {
  it("success", async () => {
    // delete testBase.httpApiEvent.requestContext.authorizer;
    const handler = new AuthorizeHandlerTest();
    const result = await handler.execute(FlightTestHelper.stubAuthorizerEvent(), FlightTestHelper.stubContext());
    result.should.match(FlightTestHelper.stubAuthorizerResult());
  });

  it("error", async () => {
    // delete testBase.httpApiEvent.requestContext.authorizer;
    const handler = new AuthorizeHandlerTestError();
    return handler
      .execute(FlightTestHelper.stubAuthorizerEvent(), FlightTestHelper.stubContext())
      .should.be.rejectedWith("error");
  });
});

// tslint:disable:max-classes-per-file
class AuthorizeHandlerTest extends AuthorizerHandler {
  public async run(event: CustomAuthorizerEvent, context: Context): Promise<CustomAuthorizerResult> {
    return FlightTestHelper.stubAuthorizerResult();
  }
}

class AuthorizeHandlerTestError extends AuthorizerHandler {
  public async run(event: CustomAuthorizerEvent, context: Context): Promise<CustomAuthorizerResult> {
    throw new Error("error");
  }
}
